import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

const isEvenNumber = (num) => num % 2 == 0;

const Head = ({ numColumns, showEvenCol }) => {
  const cols = [...Array(numColumns)].map((_, i) => {
    if (showEvenCol && !isEvenNumber(i + 1)) return null;

    if (!showEvenCol && isEvenNumber(i + 1)) return null;

    return <th key={i}>{`${i + 1}"`}</th>;
  });
  return (
    <thead>
      <tr>
        <th />
        {cols}
      </tr>
    </thead>
  );
};

const Body = ({
  numRows,
  numColumns,
  pricing,
  rowSelected,
  columnSelected,
  showEvenCol,
}) => {
  return (
    <tbody>
      {[...Array(numRows)].map((_, i) => (
        <tr key={i}>
          <BodyRow
            row={i}
            numColumns={numColumns}
            pricing={pricing}
            rowSelected={rowSelected}
            columnSelected={columnSelected}
            showEvenCol={showEvenCol}
          />
        </tr>
      ))}
    </tbody>
  );
};

const BodyRow = ({
  numColumns,
  row,
  pricing,
  rowSelected,
  columnSelected,
  showEvenCol,
}) => {
  const cells = [<td key={`header-${row}`}>{`${row + 1}"`}</td>];
  cells.push(
    [...Array(numColumns)].map((_, j) => {
      if (showEvenCol && !isEvenNumber(j + 1)) return null;

      if (!showEvenCol && isEvenNumber(j + 1)) return null;

      return (
        <BodyItem
          key={j}
          row={row}
          column={j}
          pricing={pricing}
          rowSelected={rowSelected}
          columnSelected={columnSelected}
        />
      );
    }),
  );

  return <>{cells}</>;
};

const priceFormatter = (value) => {
  if (value === undefined || value === null) return '';
  return `$${value.toFixed(2)}`;
};

const BodyItem = ({ row, column, pricing, rowSelected, columnSelected }) => {
  const className =
    row === parseInt(rowSelected) && column === parseInt(columnSelected)
      ? 'selected'
      : '';
  const klass = classNames('pricing-item', className);
  return (
    <td>
      <span className={klass}>{priceFormatter(pricing[row][column])}</span>
    </td>
  );
};
const Pricing = ({ parameters, quote }) => {
  const [showEvenCol, setShowEvenCol] = useState(true);

  if (!quote || !quote.line_items) return null;

  const pricing = quote.line_items[0].pricing;

  const { row_selected, column_selected } = parameters;

  const numRows = 24;
  const numColumns = 20;

  useEffect(() => {
    setShowEvenCol(
      column_selected === undefined ||
        column_selected === null ||
        isEvenNumber(parseInt(column_selected) + 1),
    );
  }, [column_selected]);

  return (
    <div className='pricing'>
      <h2 className='parameters-title'>
        Prices will automatically refresh after selecting a material thickness
        and hardware.
      </h2>
      <div className='table-responsive'>
        <table className='table table-striped table-pricing'>
          <Head numColumns={numColumns} showEvenCol={showEvenCol} />
          <Body
            numRows={numRows}
            numColumns={numColumns}
            pricing={pricing}
            rowSelected={row_selected}
            columnSelected={column_selected}
            showEvenCol={showEvenCol}
          />
        </table>
      </div>
    </div>
  );
};

export default Pricing;
